/**
 * Tax docs (P60, P45, P11D) as desktop sidebar page items, grouped by tax year under a divider,
 * with a row for each expected P60 that hasn't been added yet.
 */
export function useTaxDocsSidebar(registerSidebar = null) {
    function registerTaxDocsSidebar(groups, handlers) {
        if (!registerSidebar)
            return;
        const items = groups.flatMap(g => [
            { id: `year-${g.year}`, title: g.year, isDivider: true },
            ...g.forms.map(f => ({ id: f.id, title: f.kind, subtitle: f.employer || f.fileName, meta: f.headline || null })),
            ...g.missing.map(kind => ({ id: `missing-${g.year}-${kind}`, title: kind, subtitle: 'Not added yet, click to add' })),
        ]);
        registerSidebar({
            config: {
                actionButton: { icon: 'mdi-whatsapp', label: 'Send a tax doc' },
                pageItemsTitle: 'Tax docs',
                pageItemsEmptyText: 'No tax docs yet',
                pageItems: items,
            },
            handlers: {
                onActionClick: () => handlers.onAdd(),
                onPageItemClick: (id) => id.startsWith('missing-') ? handlers.onAdd() : handlers.onOpenDoc(id),
                onPageItemDelete: () => { },
                onPageItemRename: () => { },
                onOpenSettings: () => handlers.onOpenSettings(),
            },
        });
    }
    return { registerTaxDocsSidebar };
}
